/**
 * What several power-up effects do to the world alike: pause play while the border flashes, clear the
 * C64's software sprites, kill every monster, announce an effect. Monsters die only through the BUBBLE
 * stream's `killMonsterBy`, so they fly off and land as their death items as a burst monster does.
 */

import { killMonsterBy } from '../bubbles';
import type { ItemSystem } from './state';
import type { PlayerId, SimEvent, World } from '../types';

type Effect = Extract<SimEvent, { type: 'effect' }>['effect'];

/** A world-wide effect begins (the renderer's banner, the audio's cue). */
export function announce(world: World, effect: Effect): void {
  world.events.push({ type: 'effect', effect });
}

/**
 * The C64 stops its main loop (and the players' and monsters' IRQ updates, `inc $37`) while the border
 * flashes: `flow.freeze`, as `endRound` invites. `flashUntil` tells the renderer.
 */
export function pause(world: World, sys: ItemSystem, frames: number): void {
  world.flow.freeze = Math.max(world.flow.freeze, frames);
  sys.flashUntil = Math.max(sys.flashUntil, world.flow.frame + frames);
}

/**
 * D_2E79 clears all 18 software-sprite slots: the monsters' shots and the Barons go. (The bubbles are
 * the BUBBLE stream's slots and stay; see the report.)
 */
export function clearSoftware(world: World): void {
  world.projectiles.length = 0;
  world.barons.length = 0;
}

/**
 * D_2E61: every monster still alive - out, or carried by water ($0D) - dies through D_1A6F (a purple
 * diamond, $8892 = 9); `by` is the player who took the power-up. The C64 first lets trapped monsters
 * out of their bubbles (D_2E79), so they die too.
 */
export function killAll(world: World, by: PlayerId): void {
  for (const m of world.monsters.slice()) {
    if (m.state !== 'dead') killMonsterBy(world, m.id, 'other', by);
  }
}
